import React from 'react';

const BulkClearArrivalModal = ({
  show,
  onClose,
  selectedCount,
  onConfirm,
  loading,
  confirmMessage
}) => {
  if (!show) return null;
  return (
    <>
      <div className="modal-backdrop show" style={{ zIndex: 1040 }} />
      <div
        className="modal show"
        tabIndex="-1"
        role="dialog"
        style={{ display: 'block', zIndex: 1050 }}
        onClick={() => !loading && onClose()}
      >
        <div className="modal-dialog modal-dialog-centered" role="document" onClick={e => e.stopPropagation()}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Очистити дату надходження</h5>
              <button type="button" className="close" aria-label="Close" onClick={() => !loading && onClose()}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body text-left">
              {!confirmMessage && (
                <p className="mb-0">
                  Очистити дату надходження для {selectedCount} обраних товарів?
                </p>
              )}
              {confirmMessage === 'success' && (
                <div className="alert alert-success mb-0" role="alert">
                  Дату надходження очищено.
                </div>
              )}
              {confirmMessage && confirmMessage !== 'success' && (
                <div className="alert alert-danger mb-0" role="alert">
                  {confirmMessage.text}
                </div>
              )}
            </div>
            <div className="modal-footer">
              {!confirmMessage ? (
                <button type="button" className="btn btn-dark btn-block" onClick={onConfirm} disabled={loading}>
                  {loading ? 'Застосування…' : 'Підтвердити'}
                </button>
              ) : (
                <button type="button" className="btn btn-dark btn-block" onClick={onClose}>
                  Закрити
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BulkClearArrivalModal;
